import { createAsyncThunk } from "@reduxjs/toolkit";
import { axios } from "services/axios";

  /* -------------------------------------- Get Menu Engineering Report List ------------------------------- */
  export const getModifierOptionsReportList = createAsyncThunk("modifierOptionsCostReport/getModifierOptionsReportList",  
    async (args, thunkApi) => {
    try {
      const { data } = await axios.get(`https://rostoapi.smartgate-egypt.com/Reports/GetModifierOptionsCostReport`);
      return thunkApi.fulfillWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e.response.data);
    }
  }
);
 /* --------------------------------------- Menu Engineering Filter Data ------------------------------*/
 export const getModifierOptionsFilteredData = createAsyncThunk("modifierOptionsCostReport/getModifierOptionsFilteredData ", 
  async (args, thunkApi) => {
  try {
    return (args);
  } catch (e) {
    return thunkApi.rejectWithValue(e.response.data);
  }
}
);
export const resetModifierOptionsFilteredData = createAsyncThunk( "modifierOptionsCostReport/resetModifierOptionsFilteredData ", 
  async (args, thunkApi) => { 
  try {
    return args;
  } catch (e) {
    return thunkApi.rejectWithValue(e.response.data);
  }
}
);